import React from 'react';
import MenuCliente from '../Components/MenuCliente/menucliente';
import './emissao.css';

function Emissao(){
    return <div>      
      <MenuCliente />      
    </div>;
  }

export default Emissao;